import { MappingEmpty, mappingEmptyTag } from '@ni/nimble-components/dist/esm/mapping/empty';
import { wrap } from '../../utilities/react-wrapper';

export { mappingEmptyTag };
export { type MappingEmpty };
export const NimbleMappingEmpty = wrap(MappingEmpty);
